// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 34) return "js/backend/category.js";
	if (chunkId === 712) return "js/backend/department.js";
	if (chunkId === 314) return "js/backend/productdetails.js";
	if (chunkId === 443) return "js/backend/about.js";
	if (chunkId === 631) return "js/backend/contact.js";
	if (chunkId === 720) return "js/backend/faq.js";
	if (chunkId === 523) return "js/backend/shop.js";
	if (chunkId === 940) return "js/backend/request.js";
	if (chunkId === 966) return "js/backend/dashboard.js";
	if (chunkId === 685) return "js/backend/register.js";
	if (chunkId === 535) return "js/backend/login.js";
	if (chunkId === 845) return "js/backend/profile.js";
	if (chunkId === 954) return "js/backend/others.js";
	if (chunkId === 387) return "js/backend/orderview.js";
	if (chunkId === 883) return "js/backend/servicepayment.js";
	if (chunkId === 843) return "js/backend/resend-otp.js";
	if (chunkId === 12) return "js/backend/verify-account.js";
	if (chunkId === 141) return "js/backend/141.js";
	if (chunkId === 617) return "js/backend/617.js";
	// return url for filenames based on template
	return undefined;
};